<template>
  <div>
    <div class="flex justify-between items-center my-4">
      <h5><i class="dot"></i> {{ title }}</h5>
      <input ref="fileInput" type="file" style="display: none" @change="handleChangeFile" />
      <div v-if="isChange" class="hidden xl:block">
        <vs-button color="secondary" type="border" @click="fileDownloadAll"> 전체 다운로드 </vs-button>
        <vs-button class="ml-4" color="secondary" @click="openFileInput"> 파일추가 </vs-button>
        <vs-button class="ml-4" color="secondary" type="border" @click="fileRemove" :disabled="selected.length < 1"> 선택삭제 </vs-button>
      </div>
    </div>
    <vs-table :multiple="isChange" v-model="selected" :data="tableList" class="filedownload-table w-full" noDataText="파일이 없습니다">
      <template slot="thead">
        <vs-th class="hidden xl:table-cell text-sm" style="width: 80px;">
          <p class="w-full text-center">연번</p>
        </vs-th>
        <vs-th class="text-sm">
          <p class="w-full text-center">파일명</p>
        </vs-th>
        <vs-th class="hidden xl:table-cell text-sm">
          <p class="w-full text-center">업로드 시각</p>
        </vs-th>
        <vs-th class="hidden xl:table-cell text-sm">
          <p class="w-full text-center">업로드 팀원</p>
        </vs-th>
        <vs-th class="hidden xl:table-cell text-sm text-center">
          <p class="w-full text-center">파일크기</p>
        </vs-th>
        <vs-th class="w-24 text-sm">
          <p class="w-full text-center">다운로드</p>
        </vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td class="hidden xl:table-cell" style="width: 80px;">
            <p class="w-full text-center">{{ tableList.length - indextr }}</p>
          </vs-td>
          <vs-td class="xl:hidden">
            <div class="flex items-center gap-2">
              <p class="font-medium text-base">{{ tr.name }}</p>
              <p class="font-normal text-sm" style="color: #9ca0a4">{{ tr.size }}</p>
            </div>
            <div class="font-normal text-sm">
              {{ tr.date | moment("YYYY-MM-DD, HH:ss,") }}
              {{ tr.user }}
            </div>
          </vs-td>
          <vs-td class="hidden xl:table-cell">
            <p class="w-full text-center">{{ tr.name }}</p>
          </vs-td>
          <vs-td class="hidden xl:table-cell">
            <p class="w-full text-center">
              {{ tr.date | moment("YYYY-MM-DD HH:ss") }}
            </p>
          </vs-td>
          <vs-td class="hidden xl:table-cell">
            <p class="w-full text-center">{{ tr.user }}</p>
          </vs-td>
          <vs-td class="hidden xl:table-cell">
            <p class="w-full text-center">{{ tr.size }}</p>
          </vs-td>
          <vs-td @click.stop>
            <div class="flex justify-center">
              <button @click.stop="() => onClickFileDownload(tr.name, tr.path)" style="background: none" class="border-0 cursor-pointer">
                <feather-icon icon="DownloadIcon" />
              </button>
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <div v-if="isChange" class="xl:hidden flex items-center justify-end gap-4 py-3">
      <vs-button class="" color="secondary" @click="openFileInput"> 파일추가 </vs-button>
      <vs-button color="secondary" type="border" @click="fileRemove" :disabled="selected.length < 1"> 선택삭제 </vs-button>
    </div>
  </div>
</template>

<script>
import { downloadFile } from "@/util/DataUtil";

export default {
  props: {
    title: { type: String, default: "관련 서식 다운로드" },
    value: { type: Array, default: () => [] },
    isPrint: Boolean,
    isReadonly: Boolean,
    isChange: { type: Boolean, default: true },
    boardId: String | Number,
    maxImgWidth: Number,
  },
  data() {
    return {
      selected: [],
      tableList: this.value,
    };
  },
  computed: {
    myInfo() {
      return this.$store.state.auth.userInfo;
    },
    boardSlug() {
      if (this.boardId) {
        return `board-${this.boardId}`;
      }
      return `board-${this.$route.params.boardId}`;
    },
  },
  watch: {
    value: {
      handler(value) {
        this.tableList = value;
      },
    },
    tableList: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    async fileUpload(files) {
      if (files.length > 0) {
        await this.$store.dispatch("file/FILE_UPLOAD", files[0]);
        const fileInfo = this.$store.state.file.uploadedFile;

        let sizeCheck = fileInfo.fileSize;
        if (sizeCheck < 1000) sizeCheck = `${sizeCheck}B`;
        else if (sizeCheck < 1000000) sizeCheck = `${(sizeCheck * 0.001).toFixed(1)}KB`;
        else sizeCheck = `${(sizeCheck * 0.000001).toFixed(1)}MB`;

        this.tableList.unshift({ id: fileInfo.id, name: fileInfo.fileName, size: sizeCheck, date: new Date(), user: this.myInfo.name, path: fileInfo.path });
      }
      this.$refs.fileInput.value = null;
    },
    async fileRemove() {
      if (this.selected.length < 1) return;
      const _confirm = confirm("선택한 파일을 삭제하시겠습니까?");
      if (!_confirm) return;

      const ids = this.selected.map((s) => s.id);
      this.tableList = this.tableList.filter((fl) => !ids.includes(fl.id));

      this.selected = [];
    },
    onClickFileDownload(filename, path) {
      downloadFile(filename, path);
    },
    openFileInput() {
      this.$refs.fileInput.click();
    },
    handleChangeFile(event) {
      this.fileUpload(event.target.files);
    },
    fileDownloadAll() {
      this.tableList.forEach((file) => {
        downloadFile(file.name, file.path);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.filedownload-table::v-deep {
  th {
    padding: 9px 15px !important;
  }

  td {
    background: white !important;
    padding: 6px 15px !important;
  }

  .vs-table--tbody-table {
    min-width: auto;
  }
  .vs-con-tbody {
    border: 0;
  }

  tr {
    background: white;
    border-top: solid 1px #cdcdcd;
    border-bottom: solid 1px #cdcdcd;
    transform: translateY(0px) !important;
  }
  th {
    background: #f9f9f9;
    font-size: 14px !important;
  }
}

.delete-button-container {
  position: absolute;
  top: -8px;
  right: -8px;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  border-radius: 999px;
  border: 1px solid #222;
  cursor: pointer;

  > img {
    position: relative;
    width: 12px;
    height: 12px;
  }
}
</style>
